module.exports = __webpack_public_path__ + "img/pay-as-little-as-25.e420bc62.svg";